import React, { Fragment } from 'react'

import ControlBar from './ControlBar'
import MultiRowsActions from './table/MultiRowsActions'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import IntegrationsLoader from './_load/IntegrationsLoader'
import IntegrationsTable from './table/IntegrationsTable'

const PageContent = () => {
  return (
    <Fragment>
      <ControlBar />

      <MultiSelectHandler>
        <IntegrationsLoader uncontrolledChildren={<MultiRowsActions />}>
          <IntegrationsTable />
        </IntegrationsLoader>
      </MultiSelectHandler>
    </Fragment>
  )
}

export default PageContent
